<template>
    <router-view></router-view>
    <PwaInstall />
</template>

<script setup>
import PwaInstall from './Components/shared/PwaInstall.vue';
</script>
